//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum, EventLocationIcon } from './Enums';

export class EventLocationNameDisplayItem extends ItemBase {
    Color: EventColorEnum = EventColorEnum.Beach;
    Icon: EventLocationIcon | null = null;
    ID: string | null = null;
    Name: string | null = null;
    Description: string | null = null;

    constructor(initializer?: Partial<EventLocationNameDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "EventLocationNameDisplayItem";
}
